export default {
  data() {
    return {
      total: 0,
      shippingCost: 0,
      items: {
        quantity: 0,
        total: 0,
      },
    };
  },
  watch: {
    async cart(cart, oldCart) {
      if (!oldCart && cart) {
        await this.init();
        this.checkPaymentStatus();
      }
    }
  },
  computed: {
    couponsEnabled() {
      if (this.$store.getters.COUPONS_ENABLED) {
        return true;
      }

      return false;
    },
    personalData() {
      return this.checkout.personalData;
    },
    shippingOption() {
      return this.checkout.shippingOption;
    },
    shippingAddress() {
      let shippingAddress;

      if (this.shippingOption.shippingOptionId === 4) {
        shippingAddress = this.shippingOption.address;
      } else {
        const personalData = this.personalData;

        shippingAddress = `
          ${personalData.shipping_address
            ? personalData.shipping_address_street
            : personalData.street},
          ${personalData.shipping_address
            ? personalData.shipping_address_zip
            : personalData.zip}
          ${personalData.shipping_address
            ? personalData.shipping_address_city
            : personalData.city}`;
      }

      return shippingAddress;
    },
    paymentOption() {
      return this.checkout.paymentOption;
    },
    shippingSurcharges() {
      return +this.tmpOrder.shipping_surcharges;
    },
    couponPrice() {
      return this.tmpOrder && this.tmpOrder.original_total_price > this.tmpOrder.total_price
          ? this.tmpOrder.original_total_price - this.tmpOrder.total_price
          : 0;
    },
  },
  methods: {
    async init() {
      const cart = JSON.stringify(this.cart);
      const checkout = this.checkout;

      let form = {
        payment_option_id: checkout.paymentOption ? checkout.paymentOption.payment_option.id : 0,
      };

      if (checkout.shippingOption) {
        if (checkout.shippingOption.shippingRateId) {
          form.shop_shipping_rate_id = checkout.shippingOption.shippingRateId;
        }

        if (checkout.shippingOption.shippingOptionId === 4) {
          form.shop_individual_shipping_option_id = checkout.shippingOption.id;
        } else {
          form.shop_shipping_option_id = checkout.shippingOption.id;
        }
      }

      const path = this.$router.currentRoute.path.split('/');

      if (path[path.length - 1] === 'success' || path[path.length - 2] === 'success') {
        const localCheckout = await localStorage.getItem('checkout');

        if (localCheckout) {
          const data = JSON.parse(localCheckout);
          this.assignTmpOrder(data.tmpOrder);
        }
      } else {
        const loader = this.$loading.show();

        try {
          let response = await this.axios.put(
              `v2/temp-order/${checkout.authType}/${this.tmpOrder.id}`,
              {cart, form});

          if (response.data && response.data.success) {
            response.data.data.flags = response.data.flags;
            this.assignTmpOrder(response.data.data);
          }

          if (!checkout.coupon) {
            this.showRandomCouponBanner();
          }

          loader.hide();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
          loader.hide();
        }
      }
    },
    assignTmpOrder(data) {
      this.total = data.grandtotal;
      /*this.total = parseFloat(data.total_price) +
          parseFloat(data.shipping_cost) +
          parseFloat(data.shipping_surcharges) || 0;*/

      this.shippingCost = data.shipping_cost || 0;
      this.items.quantity = 0;

      data.order_items.forEach(item => {
        this.items.total += parseFloat(item.price);

        if (item.album_item_id) {
          this.items.quantity++;
        }
      });

      this.$store.dispatch('SET_TMP_ORDER', data);
    },
    editCart() {
      this.$router.push(this.i18nLink('cart'));
    },
    goToPaymentOptions() {
      this.$store.dispatch('SET_CHECKOUT_STEP', this.checkoutStep - 1);
    },
    gotToCoupon() {
      this.$store.dispatch('SET_CHECKOUT_STEP', this.checkoutStep - 2);
    },
    gotToShippingOptions() {
      this.$store.dispatch('SET_CHECKOUT_STEP', this.checkoutStep - 3);
    },
  },
  created() {
    this.$emit('info', this.$t('overview'));

    if (this.cart) {
      this.init();
      this.checkPaymentStatus();
    }

    localStorage.setItem('checkout', JSON.stringify({
      shippingOptions: this.shippingOptions,
      paymentOptions: this.paymentOptions,
      paymentConfigs: this.paymentConfigs,
      checkout: this.checkout,
      tmpOrder: this.tmpOrder,
    }));
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  },
};
